import React from 'react';
import FilterCategory from './filterCategory';
import CheckBox from '../../../common/components/checkbox';
import { toggleChoice } from '../filterListSlice';
import { useDispatch } from 'react-redux';
import { MultiOptionCategory, CardListFilterState } from '../types';
import { toggleOptionsVisibility } from '../filterListSlice';
import { useSelector } from 'react-redux';

interface FilterProps {
  category: MultiOptionCategory;
  index: number;
}
const MultiChoiceFilter = ({ category, index }: FilterProps) => {
  const dispatch = useDispatch();
  const translations = useSelector(
    (state: CardListFilterState) => state.translations,
  );

  if (category && category.options && category.options.length > 0) {
    const isOverLimit = category.options.length > 5;
    const visibleOptions =
      !isOverLimit || (isOverLimit && category.showAll)
        ? category.options
        : category.options.slice(0, 5);
    return (
      <FilterCategory
        icon={category.icon}
        name={category.name}
        index={index}
        closed={category.closed}
      >
        {visibleOptions.map((option, optionIndex) => {
          return (
            <div
              className='tour__filter__checkbox'
              key={`co_${category.id}_${option.id}`}
            >
              <CheckBox
                checked={option.selected}
                text={option.name}
                disabled={option.disabled}
                onChange={() =>
                  dispatch(toggleChoice({ categoryIndex: index, optionIndex }))
                }
              />
              <div className='tour__filter__checkbox__count'>
                {option.count}
              </div>
            </div>
          );
        })}
        {isOverLimit ? (
          <div
            className='tour__filter__option__toggle'
            onClick={() => dispatch(toggleOptionsVisibility(index))}
          >
            {category.showAll ? (
              <>
                {translations.less}&nbsp;
                <i className='fas fa-caret-up' />
              </>
            ) : (
              <>
                {translations.more}&nbsp;
                <i className='fas fa-caret-down' />
              </>
            )}
          </div>
        ) : null}
      </FilterCategory>
    );
  } else {
    return null;
  }
};

export default MultiChoiceFilter;
